// <auto-generated>
//     Generated from the platform feature flag catalogue by scripts/generateFeatureFlags.js.
//     Do not edit by hand: run "npm run graphql:generate-feature-flags" instead.
// </auto-generated>

/**
 * Well-known feature flags.
 *
 * A const object rather than an enum on purpose: the value stays a plain string at runtime, so a
 * flag the server knows but this build does not is data rather than a deserialization failure,
 * while call sites still get compile-time checking.
 */
export const FeatureFlag = {
  /** Cloud Solutions */
  CloudSolutions: "cloud-solutions",
  /** Cloud Data Sources */
  DataSources: "data-sources",
  /** Projects */
  Projects: "projects",
  /** Rates */
  Rates: "rates",
  /** Web services */
  WebServices: "web-services"
} as const;

// The value and the type deliberately share a name: call sites get an enum-like type while the
// runtime value stays a plain string.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];

/** Human-readable names, so an unlicensed feature can be named to the user without a second query. */
export const FeatureFlagDisplayName: Record<string, string> = {
  "cloud-solutions": "Cloud Solutions",
  "data-sources": "Cloud Data Sources",
  "projects": "Projects",
  "rates": "Rates",
  "web-services": "Web services"
};
